module.exports = (numero,tipo = 'entero', presision = 0,decimal='',nomina_entero='') => {//numero= es el numero a ser convertido; tipo=(entero:solo convierte parte entera; digitos: nombra al numero por cada uno de sus digitos; decimal: convierte la parte entera y decimal; nominal: le da una denominacion a los decimales); decimal= nomenglatura de la parte decimal; nomina_entero=  nomenglatura de la parte entera; presision= es la presision decimal a convertir(0:ningun decimal; -1: todos los decimales)
    if (typeof(numero) === 'number') {
        var respuesta = '';

        if (numero < 0) {
            numero *= -1;
            respuesta += ' MENOS '
        }

        if (tipo === 'entero') {
                respuesta += n_t_l(parseInt(numero)+'');
        } else if (tipo === 'digitos') {
            var x = (numero + '');

            for (let i = 0; i < x.length; i++) {
                respuesta += unidades(x[i]);
            }
        } else if (tipo === 'decimal') {
            var x = (numero + '');

            var y = x.indexOf(".");

            var entero = x.slice(0,y);
            var decimales = x.slice(y - x.length);

            respuesta += n_t_l(entero);

            if (presision > 0) {
                for (let i = 0; i < decimales.length && i < presision + 1; i++) {
                    respuesta += unidades(decimales[i]);
                }                    
            }
        } else if (tipo === 'nominal') {
            var x = (numero + '');

            var y = x.indexOf(".");

            var entero = x.slice(0,y);
            var decimales = x.slice(y - x.length + 1);

            if (decimales.length < presision) {
                for (let i = decimales.length; i < presision; i++) {
                    decimales += '0';
                }
            }else if(decimales.length > presision){
                decimales = decimales.slice(0,presision-decimales.length);
            }

            respuesta += n_t_l(entero) + ' ' + nomina_entero; 
            if (presision > 0) {
                respuesta += ' CON ' + n_t_l(decimales) + ' ' + decimal;  
            }
        }

        return respuesta;
    } else {
        return 'Numero Inválido';
    }
}

function n_t_l(n) {
    var respuesta = '';

    if (n.length > 12) {
        var num = n.slice(0,-12);
        var num_n = n.slice(-12);

        if (parseInt(num) == 1) {
            respuesta += ' UN BILLÓN';
        } else {
            respuesta = n_t_l(num);
            respuesta += ' BILLONES';            
        }
        respuesta += n_t_l(num_n);
    } else if (n.length > 6) {
        var num = n.slice(0,-6);
        var num_n = n.slice(-6);

        if (parseInt(num) == 1) {
            respuesta += ' UN MILLÓN';
        } else {
            respuesta = n_t_l(num);
            respuesta += ' MILLONES';            
        }
        respuesta += n_t_l(num_n);
    } else if (n.length > 3) {
        var num = n.slice(0,-3);
        var num_n = n.slice(-3);

        if (parseInt(num) == 1) {
            respuesta += ' MIL';
        } else {
            respuesta = n_t_l(num);
            respuesta += ' MIL';            
        }
        respuesta += n_t_l(num_n);
    } else if (n.length > 2) {
        var num = n.slice(0,-2);
        var num_n = n.slice(-2);

        if (parseInt(n) == 100) {
            respuesta += ' CIEN';
        } else {
            respuesta = centenas(num);        
        }
        respuesta += n_t_l(num_n);
    } else if (parseInt(n) < 100 && parseInt(n) > 19) {
        respuesta = decenas(n.slice(0,1));
        if (n.slice(-1) != '0') {
            respuesta += ' Y ' + unidades(n.slice(-1));
        }
    } else {
        if (n.length > 1) {
            if(parseInt(n) != 0){
                respuesta = unidades(parseInt(n) + '');
            }
        }else{
            respuesta = unidades(parseInt(n) + '');
        }
    }

    return respuesta;
}

function unidades(n) {
    switch (n) {
        case '1':
            return ' UNO'
            break;
        case '2':
            return ' DOS'
            break;
        case '3':
            return ' TRES'
            break;
        case '4':
            return ' CUATRO'
            break;
        case '5':
            return ' CINCO'
            break;
        case '6':
            return ' SEIS'
            break;
        case '7':
            return ' SIETE'
            break;
        case '8':
            return ' OCHO'
            break;
        case '9':
            return ' NUEVE'
            break;
        case '0':
            return ' CERO'
            break;
        case '11':
            return ' ONCE'
            break;
        case '12':
            return ' DOCE'
            break;
        case '13':
            return ' TRECE'
            break;
        case '14':
            return ' CATORCE'
            break;
        case '15':
            return ' QUINCE'
            break;
        case '16':
            return ' DIECISEIS'
            break;
        case '17':
            return ' DIECISIETE'
            break;
        case '18':
            return ' DIECIOCHO'
            break;
        case '19':
            return ' DIECINUEVE'
            break;
        case '10':
            return ' DIEZ'
            break;
        case '-':
            return ' GUIÓN'
            break;
        case '.':
            return ' PUNTO'
            break;
        case ',':
            return ' COMA'
            break;
        case '+':
            return ' MÁS'
            break;

        default:
            return ''
            break;
    }
}

function decenas(n) {
    switch (n) {
        case '2':
            return ' VEINTE'
            break;
        case '3':
            return ' TEINTA'
            break;
        case '4':
            return ' CUARENTA'
            break;
        case '5':
            return ' CINCUENTA'
            break;
        case '6':
            return ' SESENTA'
            break;
        case '7':
            return ' SETENTA'
            break;
        case '8':
            return ' OCHENTA'
            break;
        case '9':
            return ' NOVENTA'
            break;
    
        default:
            return ''
            break;
    }
}

function centenas(n) {
    switch (n) {
        case '1':
            return ' CIENTO'
            break;
        case '2':
            return ' DOCIENTOS'
            break;
        case '3':
            return ' TRECIENTOS'
            break;
        case '4':
            return ' CUATROCIENTOS'
            break;
        case '5':
            return ' QUINIENTOS'
            break;
        case '6':
            return ' SEISCIENTOS'
            break;
        case '7':
            return ' SETECIENTOS'
            break;
        case '8':
            return ' OCHOCIENTOS'
            break;
        case '9':
            return ' NOVECIENTOS'
            break;
    
        default:
            return ''
            break;
    }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/numeros_a_letras/index.js
// module id = RCy7
// module chunks = 0